var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "globalSearch",
      staticClass: "header-global-search",
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.closeGlobalSearch.apply(null, arguments)
        }
      }
    },
    [
      _vm.$route?.meta?.hasGlobalSearch
        ? _c(
            "div",
            {
              class: [
                "global-search-input-container",
                { hide: _vm.isSearchOpened }
              ]
            },
            [
              _c("img", {
                staticClass: "global-search-open",
                attrs: {
                  src: require(`@/drc/assets/icons/search-glass.svg`),
                  alt: "search"
                },
                on: { click: _vm.openGlobalSearch }
              }),
              _c("input", {
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("globalSearchSections.searchPlaceholder")
                },
                on: { click: _vm.openGlobalSearch }
              })
            ]
          )
        : _vm._e(),
      _vm.isSearchOpened
        ? _c("div", { staticClass: "global-search-result-container" }, [
            _c("div", { staticClass: "results-container" }, [
              _c(
                "div",
                {
                  class: [
                    "headline",
                    { "extra-padding": _vm.projects.length <= 4 }
                  ]
                },
                [
                  _c("span", { staticClass: "spacer" }),
                  _c("div", { class: ["result-search"] }, [
                    _c("img", {
                      staticClass: "global-search-open",
                      attrs: {
                        src: require(`@/drc/assets/icons/search-glass.svg`),
                        alt: "search"
                      },
                      on: { click: _vm.doGlobalSearch }
                    }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchText,
                          expression: "searchText"
                        }
                      ],
                      ref: "autoFocusInput",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t(
                          "globalSearchSections.searchPlaceholder"
                        )
                      },
                      domProps: { value: _vm.searchText },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.doGlobalSearch.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.searchText = $event.target.value
                        }
                      }
                    }),
                    _vm.searchText.trim() !== ""
                      ? _c("img", {
                          staticClass: "global-search-close",
                          attrs: {
                            src: require(`@/drc/assets/icons/x_black.svg`),
                            alt: "x"
                          },
                          on: { click: _vm.clearSearch }
                        })
                      : _vm._e()
                  ]),
                  _c("button", { on: { click: _vm.closeGlobalSearch } }, [
                    _c("img", {
                      attrs: {
                        src: require(`@/drc/assets/icons/x_black.svg`),
                        alt: "x"
                      }
                    })
                  ])
                ]
              ),
              _c("div", { staticClass: "result-body" }, [
                _c("div", { staticClass: "suggestions-container" }, [
                  _vm.projects.length > 0
                    ? _c("h2", [
                        _vm._v(
                          _vm._s(_vm.$t("globalSearchSections.suggestions"))
                        )
                      ])
                    : _vm._e(),
                  _vm.projects.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "suggestions-list" },
                        _vm._l(Object.entries(_vm.searchData), function(
                          [key, item],
                          index
                        ) {
                          return item.projects?.length > 0
                            ? _c(
                                "li",
                                {
                                  key: index,
                                  class: [{ "is-selected": item.isSelected }],
                                  on: {
                                    click: function($event) {
                                      return _vm.select(key)
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          `globalSearchSections.${item.name}`
                                        )
                                      )
                                    )
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("@/drc/assets/icons/arrows/arrow-up-right.svg"),
                                      alt: "arrow"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    : _vm._e()
                ]),
                _c("div", { staticClass: "match-container" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("globalSearchSections.projects")))
                  ]),
                  _vm.projects.length > 0
                    ? _c("div", { staticClass: "match-projects-wrapper" }, [
                        _c(
                          "div",
                          {
                            class: [
                              "result-projects-container",
                              { "one-layout": _vm.projects.length === 1 }
                            ]
                          },
                          _vm._l(_vm.projects, function(project, index) {
                            return _c("ProjectCard", {
                              key: index,
                              attrs: { project: project, forceGrid: true }
                            })
                          }),
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.projects.length === 0
                    ? _c("div", { staticClass: "match-projects-wrapper" }, [
                        _c(
                          "div",
                          { staticClass: "result-projects-container" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("globalSearchSections.noMatch"))
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.projects.length > 0 &&
                  Object.entries(_vm.searchData).find(
                    ([key, value]) => value.isSelected
                  )[1].hasMoreProjects
                    ? _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              _vm.exploreMore(
                                Object.entries(_vm.searchData).find(
                                  ([key, value]) => value.isSelected
                                )[1]
                              )
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("homePage.exploreAllProjects"))
                            )
                          ]),
                          _c("img", {
                            staticClass: "arrow",
                            attrs: {
                              src: require("@/drc/assets/images/round-arrow-right.svg"),
                              alt: "arrow-right"
                            }
                          }),
                          _c("img", {
                            staticClass: "arrow-hover",
                            attrs: {
                              src: require("@/drc/assets/images/round-arrow-right-hover-transparent.svg"),
                              alt: "arrow-right"
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }